import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent, Channel, ConfirmationComponent, Integration, IntegrationService } from 'lib-trend-core';
import { takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Agent, TrendGPTMakerAPIService } from '@trendbuild/trend-gpt-maker-api';

@Component({
    selector: 'app-trendgpt-integration-agents',
    templateUrl: './trendgpt-integration-agents.v2.component.html',
    // templateUrl: './trendgpt-integration-agents.component.html',
    styleUrls: ['./trendgpt-integration-agents.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrendGPTAgentsComponent extends AbstractComponent implements OnInit {

  private trendGPTMakerAPIService: TrendGPTMakerAPIService = new TrendGPTMakerAPIService();

  integration: Integration;
  assistants: any[] = [];
  channels: Channel[] = [];
  selectedChannel: Channel;

  breadcrumb = [
    { href: '/integrations', label: 'integrations.breadcrumb.integrations' },
    { label: 'integrations.breadcrumb.agents' },
  ];

  constructor(
    injector: Injector,
    private integrationService: IntegrationService,
    private dialog: MatDialog
  ) {
    super(injector);
    this.loadingContent = true;
  }

  ngOnInit() {
    this.getIntegrationTrendGPTByCompany();
  }

  getIntegrationTrendGPTByCompany() {
    this.integrationService.getIntegrationTrendGPTByCompany()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (integration: Integration) => {
          this.integration = integration;
          this.assistants = integration.metadata["agents"] || [];
          this.loadingContent = false;
        },
        error: (err) => {
          this.alertService.error(err.error.message);
          this.loadingContent = false;
        }
      });
  }

  deleteAgent(assistant: Agent) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '600px',
      data: this.t('integrations.agents.confirmRemoveAssistant', { name: assistant.name })
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (Boolean(result) === true) {
        this.assistants = this.assistants.filter(a => a.id !== assistant.id);
        await this.trendGPTMakerAPIService.deleteById(assistant.id)
        await this.integrationService.deleteAgent(this.integration._id, assistant.id).toPromise();
      }
    });
  }

  trendGptEditAgent(integration: Integration, assistant: Agent) {
    this.router.navigate([`/integrations/trendgpt/${integration._id}/agent/${assistant.id}/edit`]);
  }

  trendGptCreateAgent(integration: Integration) {
    this.router.navigate([`/integrations/trendgpt/${integration?._id}/create`]);
  }

  getChannelsByIdAssistant(idAssistant: string): string[] {
    const assistant = this.integration.metadata["agents"]?.find((a: any) => a.id === idAssistant);
    return assistant?.channels?.map((c: any) => c.name) || [];
  }

}
